import { Robot } from 'features/main/robot'
import { Coins } from 'features/main/coins'
import { Login } from 'features/main/login'
import { Energy } from 'features/main/energy'
import { useAuthContext } from '../../core/providers/AuthProvider'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { socketClient } from '../../core/services'
import { SupportIcon } from '../../ui/icons'

import c from './assets/sass/page.module.scss'

const MainPage = () => {
    const { isAuthenticated, user, isLoading, refreshUser } = useAuthContext()
    const navigate = useNavigate()

    const state = isAuthenticated && user ? 2 : 1

    const handleFAQ = () => {
        navigate('/faq?category=tapper')
    }

    useEffect(() => {
        if (isAuthenticated && !user) {
            const timer = setTimeout(() => {
                refreshUser().catch((err) =>
                    console.error('Failed to refresh user:', err)
                )
            }, 500)
            return () => clearTimeout(timer)
        }
    }, [isAuthenticated, user, refreshUser])

    useEffect(() => {
        if (!isAuthenticated) return

        const handleBalanceUpdate = () => {
            if (!user) {
                refreshUser().catch((err) =>
                    console.error('Force refresh on balance update:', err)
                )
            }
        }

        const handleEnergyUpdate = () => {
            if (!user) {
                refreshUser().catch((err) =>
                    console.error('Force refresh on energy update:', err)
                )
            }
        }

        socketClient.on('balance_updated', handleBalanceUpdate)
        socketClient.on('energy_updated', handleEnergyUpdate)

        return () => {
            socketClient.off('balance_updated', handleBalanceUpdate)
            socketClient.off('energy_updated', handleEnergyUpdate)
        }
    }, [isAuthenticated, user, refreshUser])

    if (isLoading) {
        return (
            <div className={c.component}>
                <Robot state={0} />
            </div>
        )
    }

    return (
        <div className={c.component}>
            {state === 2 && (
                <button type="button" className={c.btn} onClick={handleFAQ}>
                    <SupportIcon />
                </button>
            )}
            {state === 1 && (
                <>
                    <Robot state={state} />
                    <Login />
                </>
            )}
            {state === 2 && (
                <>
                    <Energy />
                    <Robot state={state} />
                    <Coins />
                </>
            )}
        </div>
    )
}

export default MainPage
